import RBush from 'rbush';

import { IRBushItem } from 'shared/map-search/types/map';
import { makeContextModule } from 'shared/map-search/utils/makeContextModule';

export interface INewbuildingPromoPinsContext {
  rbush: RBush<IRBushItem>;
  newbuildingsPromoPinsManager: YMaps.NewbuildingsPromoPinsManager;
  popupManager: YMaps.NewbuildingPromoPopupManager;
}

export const {
  Context: NewbuildingPromoPinsContext,
  useContext: useNewbuildingPromoPinsContext,
  withContext: withNewbuildingPromoPinsContext,
} = makeContextModule<INewbuildingPromoPinsContext>({
  contextName: 'NewbuildingPromoPinsContext',
});
